import React from 'react';
import { Grid, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Title extends React.Component {

state = {
  set_names: [],
  load: false,
  message: ''
}

componentDidMount() {
  let context = this;
  var x = [];
  let menu = ['Active', 'Inactive'];
  menu.map((y) => {
    x.push({key: y, text: y, value: y});
  });
  try {
    context.setState({
      set_names: x,
    });
  } catch (e) {}
}

onChange = (type) => (e, {value}) => {
  this.setState({
    [type]: value,
    error: ''
  })
}

cancel() {
  this.props.handleClose();
}

update() {
  let context = this;
  let set_name= this.state.set_name;
  let tamil_name= this.state.tamil_name;
  let status = this.state.status;
  let priority = this.state.priority;

  if (set_name == '' || set_name == null || set_name == undefined) {
    this.setState({
      error: 'Enter the Assembly name',
    })
    return;
  }
  if (tamil_name == '' || tamil_name == null || tamil_name == undefined) {
    this.setState({
      error: 'Enter the Tamil name',
    })
    return;
  }
  if (status == '' || status == null || status == undefined) {
    this.setState({
      error: 'Enter the status',
    })
    return;
  }

  if (priority == '' || priority == null || priority == undefined) {
    this.setState({
      error: 'Enter the priority',
    })
    return;
  }

  let data1 = { 'set_name': set_name, 'status': status, 'tamil_name': tamil_name, 'priority': priority };
  context.setState({
    load: true,
    message: 'Adding Assembly!!!',
  });
  $.ajax({
    type: 'POST',
    data: data1,
    url: Server() + 'addmenu/setdetails/add.php',
    success: function(data)
    {
      context.setState({
        load: false,
      });
      if (data == 1) {
        context.props.updateDatas();
      }
    },
    error: function(e)
    {
      alert('Try again!!')
      context.setState({
        load: false
      });
    }
  });
}

status = (f, { value }) => {
  this.setState({ status: value })
}


render() {
  let { load, message, status, set_names, tamil_name } = this.state;
  return (
    <div>
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={16}>
        Assembly Name<br/>
        <Input fluid focus
          onChange={this.onChange('set_name')}
          placeholder='Assembly Name' />
        </Grid.Column>

        <Grid.Column mobile={16} tablet={16} computer={16}>
        Tamil Name<br/>
        <Input fluid focus
          onChange={this.onChange('tamil_name')}
          placeholder='Tamil Name' />
        </Grid.Column>

        <Grid.Column mobile={16} tablet={16} computer={8}>
          Status<br/>
          <Dropdown style={{ borderColor: '#5A9CBB' }}
           fluid selection onChange={this.status}
           options={set_names} value={status} />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          Priority<br/>
          <Input fluid focus
            onChange={this.onChange('priority')}
            placeholder='Priority' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <center style={{color: 'red'}}>{this.state.error}</center>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <Button fluid onClick={this.cancel.bind(this)}>Cancel</Button>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <Button fluid onClick={this.update.bind(this)}>Save</Button>
        </Grid.Column>
      </Grid>
      <Loading load={load} message={message} />
    </div>
  );
}
}

export default Title;
